<template>
  <div class="mobile-map-list">
    <Loading :loading="wholeLoading" />
    <div class="top-nav-mobile">
      <result-search
        ref="search"
        :searchInfo="searchInfo"
        @fromSearch="getcityInfo"
        @hotelInfo="hotelInfo"
        @locationInfo="locationInfo"
        :pageCount="pageCount"
        :searchType="searchType"
        :keywordInput="keywordInput"
        :isResultView="true"
        @gomap="toResult"
      ></result-search>
      <van-dropdown-menu>
        <!-- 星级价格排序 -->
        <van-dropdown-item v-model="sortValue" :options="priceStarOption" />
        <!-- 支付方式 -->
        <van-dropdown-item v-model="dropValue" :options="paymentOption" />
        <!-- 价格范围 -->
        <van-dropdown-item v-model="priceRangeValue" :options="priceRangeOption" :title="priceRangeTitle" @closed="priceRangeClose(priceRangeValue)"/>
        <!-- 位置距离 -->
        <van-dropdown-item :title="$t('RESULT.MOBILELOCATION')" ref="location" :title-class="titleActive" @open="distMenuOpen">
          <van-tree-select height="55vw" :items="treeSelect" v-model:main-active-index="treeActive">
            <template #content>
              <div v-if="treeActive == 0">
                <van-radio-group v-model="areaRadio">
                  <van-cell-group>
                    <van-cell  v-for="item in locationInformation" :key="item.locationCode" :title="item.locationNameLists[$t('RESULT.RESPONSEDATA.locationNameLists')]" clickable @click="areaChange(item)">
                      <template #right-icon>
                        <van-radio :name="item.locationCode" />
                      </template>
                    </van-cell>
                  </van-cell-group>
                </van-radio-group>
              </div>
              <div style="margin: 1rem" v-if="treeActive == 1">
                <p class="dist-title">{{ $t("RESULT.AIRORTRAIWAY") }}</p>
                <span v-for="way in airportslocationInfo" :key="way.locationCode">
                  <van-tag
                    v-if="way.locationNameLists && way.locationNameLists.en"
                    type="primary"
                    size="large"
                    plain
                    :class="{ 'click-dist-tag': way.locationCode == waySelected }"
                    @click="wayClick(way)"
                    >{{ way.locationNameLists[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")] }}</van-tag
                  >
                </span>
              </div>
              <div style="margin: 1rem" v-if="treeActive == 2">
                <p class="dist-title">{{ $t("RESULT.CUSTOM") }}</p>
                <span v-for="custom in customlocationInfo" :key="custom.locationCode">
                  <van-tag
                    v-if="custom.locationNameLists && custom.locationNameLists.en"
                    type="primary"
                    size="large"
                    plain
                    :class="{
                      'click-dist-tag': custom.locationCode == customSelected,
                    }"
                    @click="customClick(custom)"
                    >{{ custom.locationNameLists[$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")] }}</van-tag
                  >
                </span>
              </div>
              <div style="margin: 1rem" v-if="treeActive == 3">
                <p class="dist-title">{{ $t("RESULT.HOTHOTEL") }}</p>
                <span v-for="hotHotel in hotHotelInfo" :key="hotHotel.hotelCode">
                  <van-tag type="primary" size="large" plain :class="{ 'click-dist-tag': hotHotel.hotelCode == hotHotelSelected,}" @click="hotHotelClick(hotHotel)">
                    {{ hotHotel.hotelName[$t("RESULT.RESPONSEDATA.locationNameLists")] }}
                  </van-tag>
                </span>
              </div>
              <div style="margin: 1rem" v-if="treeActive == 4">
                <span v-for="item in starOption" :key="item.value">
                  <van-tag type="primary" size="large" plain :class="{ 'click-dist-tag': h5StarSelect.includes(item.value),}" @click="starClick(item)">
                    {{ item.text }}
                  </van-tag>
                </span>
              </div>
              <div style="margin: 1rem" v-if="treeActive == 5">
                <span v-for="item in hotelGroupOption" :key="item.value">
                  <van-tag type="primary" size="large" plain :class="{ 'click-dist-tag': item.value == hotelGroupSelect,}" @click="hotelGroupClick(item)">
                    {{ item.label }}
                  </van-tag>
                </span>
              </div>
            </template>
          </van-tree-select>
          <div style="padding: 0.5rem 1.6rem;">
            <van-button type="danger" class="top-vant-btn" block round @click="onTreeReset">
              {{ $t("MESSAGE.RESETBTN") }}
            </van-button>
            <van-button type="danger" class="top-vant-btn" block round @click="onTreeConfirm">
              {{ $t("MESSAGE.CONFIRMBTN") }}
            </van-button>
          </div>
        </van-dropdown-item>
        <van-tag type="primary" v-if="showHotelListNotice" size="large" plain @click="hotelListNoticeDialogVisible = true" class="annoucement-tag">{{ noticeTitle }}</van-tag>
        <!-- <el-button  type="primary" class="result_btn" icon="el-icon-s-unfold" @click="toResult()">
        {{ $t("RESULT.RESULT") }}</el-button> -->
        <!-- <van-dropdown-item/>
        <van-dropdown-item/> -->
      </van-dropdown-menu>
    </div>
    <div class="mainContet">
      <div id="container" class="map_area"></div>
    </div>
    <div class="list_area" v-if="isExistHotel">
      <van-swipe @change="onChange" class="my-swipe" ref="prev" :show-indicators="false">
        <van-swipe-item
          v-for="(item, index) in this.hotelList"
          :key="index"
          @click="goDetail(item)"
          width="80%"
        >
          <el-row>
            <el-col :span="24">
              <div class="hotel_title">
                {{
                  item.hotelDescriptiveInfo.name[$t("RESULT.RESPONSEDATA.name")]
                }}
              </div></el-col
            >
          </el-row>
          <el-row class="row-second">
            <el-col :span="14">
              <div>
                <svg-icon
                  v-for="item of item.hotelDescriptiveInfo.starRating"
                  :key="item"
                  icon-class="star"
                  class-name="icon-star"
                  style="width: 1.2rem; height: 1.2rem"
                ></svg-icon>
              </div>
              <div>
                <div class="row-address">
                  {{
                    item.hotelDescriptiveInfo.address[
                      $t("RESULT.RESPONSEDATA.address")
                    ]
                  }}
                </div>
                <div class="row-phone">{{ item.hotelDescriptiveInfo.contactNumber }}</div>
              </div>
            </el-col>
            <el-col :span="9">
              <el-row style="height: 5rem;text-align: center;">
                <el-col :span="24">
                  <div
                    class="pricePolicy"
                    v-if="
                       getHotelMarking(item.hotelDescriptiveInfo)!=''
                    "
                  >
                  {{getHotelMarking(item.hotelDescriptiveInfo)}}
                  </div>
                  <div
                    class="pricePolicy"
                    v-if="
                      item.isAgencyPreferredHotel && !item.isClientPreferredHotel
                    "
                  >
                    {{ $t("RESULT.CWTHOTEL") }}
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="pricePolicy" v-if="item.isClientPreferredHotel">
                    {{ getCpHotelMark(item) }}
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="pricePolicy" v-if="item.isCorpPayHotel">
                    {{ hotelListFacility(item) }}
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="pricePolicy" v-if="getNotRecommendedShow(item.hotelDescriptiveInfo.group)">
                    {{getNotRecommendedText}}
                  </div>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div>
                    <template v-if="$objBaseInfo.showTravelTitle && $objBaseInfo.displayTravelRules">
                    <div
                      v-if="
                        item.isOutOfPolicy === false &&
                        $objBaseInfo.hotelBookingRole == 1
                      "
                    >
                      <div class="policy_outof_in policy_in_color">
                        {{ $t("MESSAGE.INPOLICY") }}
                      </div>
                    </div>
                    <div v-if="item.isOutOfPolicy === true">
                      <el-tooltip placement="bottom" effect="light" :disabled="!$objBaseInfo.policySwitch">
                        <template #content>
                          <div
                            v-for="(d, i) in arrayToObj(
                              item.outOfPoliyDescriptions,
                              item.posHotelTravelRuleDescFlag,
                              item.posHotelTravelRuleDescCn,
                              item.posHotelTravelRuleDescEn,
                              item.currencyCode
                                ? $currencySign[item.currencyCode]
                                : $objBaseInfo.defaultCurrencySign
                            )"
                            :key="i"
                            v-html="d"
                          ></div>
                        </template>
                        <div
                          class="policy_outof_in policy_outof_color"
                          v-if="$objBaseInfo.hotelBookingRole == 1"
                        >
                          {{ $t("MESSAGE.OUTOFPOLICY") }}
                        </div>
                      </el-tooltip>
                    </div>
                    <div
                      v-if="
                        item.isOutOfPolicy !== false && item.isOutOfPolicy !== true
                      "
                    >
                      <div class="policy_outof_in"></div>
                    </div>
                    </template>
                    <div class="priceBottom">
                      <span
                        class="hotel_list_price_map"
                        :data-content-before="pricePrefixSuffix"
                        :data-content-after="pricePrefixSuffix"
                        >{{
                          (item.currencyCode
                            ? $currencySign[item.currencyCode]
                            : $objBaseInfo.defaultCurrencySign) +
                          item.averagePrice
                        }}</span
                      >
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </van-swipe-item>
      </van-swipe>
    </div>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
    <div v-if="noMore" class="noMore">{{ $t("RESULT.NOMORE") }}</div>
    <!-- <div class="result_btn" v-if="$objBaseInfo.channelId === 'MOBILE'">
      <el-button  type="primary" icon="el-icon-s-unfold" @click="toResult()">
        {{ $t("RESULT.RESULT") }}</el-button>
    </div> -->
    <EjectAnnouncement :centerDialogVisible="hotelListNoticeDialogVisible" @setAnnouncementFlag="setAnnouncementFlag"></EjectAnnouncement>
  </div>
</template>
<script>
import { formatDateTime, isCityGAT } from "@/utils/utils.js";
import ResultSearch from "../../components/ResultSearch.vue";
import Loading from "@/components/Loading.vue";
import { availabilityProperty,getAnnouncementInfo } from "@/api/shoppingData.js";
import ConfirmBoxs from "../../components/confirmBoxs.vue";
import { locationList, availabilityArea } from "@/api/shoppingData";
import EjectAnnouncement from "../../components/EjectAnnouncement.vue";
import { gethothotel } from "@/api/bookingData.js";
import { showToast } from "vant";
export default {
  name: "mapHotelListMobile",
  components: {
    ResultSearch,
    Loading,
    ConfirmBoxs,
    EjectAnnouncement
  },
  data() {
    return {
      confirmFlag: false,
      confirmIcon: "",
      confirmMsg: "",
      chooseCode: "",
      checkIn: "",
      checkOut: "",
      hotelID: "",
      hotelList: [],
      pageNo: 1,
      perPage: 3,
      pageCount: 3,
      noMore: false,
      disabledRequest: false,
      wholeLoading: false,
      roomNum: 1,
      guestNum: 1,
      mapDisplay: true,
      searchInfo: JSON.parse(this.$route.query.searchParam),
      map: null,
      locationArr: [],
      marketpoint: null,
      info: [],
      mapLanguage: "",
      centerPos: [], //中心点
      cityCenterPos: [], //当前城市中心点经纬度
      radiusDist: null,
      searchType: "mobileMap",
      isExistHotel: true, //是否存在酒店
      isFirstExec: true, //是否第一次加载
      initMapType: "",
      geoCodeType: "gaode",
      keywordType: "",
      keywordInput: {},
      titleActive: "", //location_active
      treeSelect: [],
      treeActive: 0,
      distSelected: null,
      // disOptions: [
      //   {
      //     value: 1,
      //     label: { "zh-CN": "1公里", en: "1KM" },
      //   },
      //   {
      //     value: 3,
      //     label: { "zh-CN": "3公里", en: "3KM" },
      //   },
      //   {
      //     value: 5,
      //     label: { "zh-CN": "5公里", en: "5KM" },
      //   },
      //   {
      //     value: 10,
      //     label: { "zh-CN": "10公里", en: "10KM" },
      //   },
      //   {
      //     value: 30,
      //     label: { "zh-CN": "30公里", en: "30KM" },
      //   },
      //   {
      //     value: 50,
      //     label: { "zh-CN": "50公里", en: "50KM" },
      //   },
      //   {
      //     value: 100,
      //     label: { "zh-CN": "100公里", en: "100KM" },
      //   },
      // ],
      areaRadio: "",
      choseArea: {},
      waySelected: "",
      customSelected: "",
      locationInformation: [],
      airportslocationInfo: [],
      customlocationInfo: [],
      labelLongitude: '', //经度
      labelLatitude: '', //经度
      coordinates: {},
      hotelListNoticeDialogVisible: false,
      noticeTitle:"",
      showHotelListNotice: false,
      hotHotelInfo: [],
      showHotHotel: false,
      hotHotelSelected: "",
      chosehotHote:{},
      isCityChange: false,
      isCorpPay: false,
      isHotelPay: false,
      isPrepay:false,
      sortValue: "nan1",
    };
  },
  computed: {
    pricePrefixSuffix() {
      return this.$t("DETAIL.ABOVE");
    },
    // 位置筛选
    getTreeSelect() {
      return [
        { text: this.$t("RESULT.DISTRICT") },
        { text: this.$t("RESULT.AIRORTRAIWAY") },
        { text: this.$t("RESULT.CUSTOM") },
        { text: this.$t("RESULT.HOTHOTEL") },
      ];
    },
    //是否隐藏不推荐
    getNotRecommendedShow(){
      return function(groupid) {
        console.log(groupid);
        let flag=false;
        if(this.$objBaseInfo.hasOwnProperty("notRecommendedModel")){
          let notRecommendedModel=this.$objBaseInfo.notRecommendedModel;
          if(notRecommendedModel!=undefined && notRecommendedModel!=null)
          {
            let arrGroupid=notRecommendedModel.notRecommendedGorupid.split(',');
            if (arrGroupid.indexOf(groupid.toString())>=0){
              flag=true;
            }
          }
        }
        return flag;
      };
    },
    getNotRecommendedText(){
      let text="";
      if(this.$objBaseInfo.hasOwnProperty("notRecommendedModel")){
        let notRecommendedModel=this.$objBaseInfo.notRecommendedModel;
        if(notRecommendedModel!=undefined && notRecommendedModel!=null)
        {
          if (this.$i18n.locale == "en")
          {
            text=notRecommendedModel.notRecommendedEN;
          }
          else
          {
            text=notRecommendedModel.notRecommendedCN;
          }
        }
      }
      return text;
    },
    //获取酒店打标
    getHotelMarking(){
      return function(hotel) {
        let value="";
        if(hotel.hasOwnProperty("cwtMark")){
          if(hotel.cwtMark!=undefined && hotel.cwtMark!=null)
          {
            let mark=hotel.cwtMark;
            if(this.$i18n.locale == "en"){
              value=mark["en"];
            }
            else
            {
              value=mark["zh-CN"];
            }
          }
        }
        return value;
      };
    },
    hotelListFacility() {
      let $this = this;
      return function (hotel) {
        var corpPayHotelName = ""
        if(hotel.isCorpPayHotel){
          if($this.isCorpPay && $this.isPrepay){
            corpPayHotelName = $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE3") + " | " + $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE2");
          }else if($this.isCorpPay){
            corpPayHotelName = $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE3");
          }else if($this.isPrepay){
            corpPayHotelName = $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE2");
          }
        }
        return corpPayHotelName;
      };
    },
    getCpHotelMark(){
      return function(item) {
        if(!item.isFixedCPHotel){
          if(this.$objBaseInfo && this.$objBaseInfo.isShowChainWide){
            return this.$t("RESULT.CHAIMWIDE");
          }
          return "";
        }
        return this.$t("RESULT.CONTRACTEDHOTEL");
      };
    },
  },
  updated() {
    this.treeSelect = this.getTreeSelect;
  },
  watch: {
    "$i18n.locale"() {
      this.map = null;
      this.initMap("auto");
    },
    // 位置距离 树形菜单选中变化 清空选中项
    treeActive(newVal) {
      if (newVal == 2 || newVal == 1) {
        this.distSelected = this.value ? this.value : 5;
      } else  if (this.$objBaseInfo.destinationType != "I"){
        this.distSelected = null;
      } else {
        this.distSelected = 5;
      }
    },
    // 排序变化
    sortValue(newVal) {
      this.sortChange(newVal);
    },
  },
  methods: {
    setPriceAffix() {
      let nodeList = document.querySelectorAll("span.hotel_list_price_map");
      if (nodeList != null && nodeList.length > 0) {
        for (const index in nodeList) {
          if (parseFloat(index).toString() != "NaN") {
            if (this.$i18n.locale === "en") {
              nodeList[index].setAttribute("data-content-after", "");
            } else {
              nodeList[index].setAttribute("data-content-before", "");
            }
          }
        }
      }
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
    toResult() {
      let mapParam = {
        checkInAt: this.checkInDate,
        checkOutAt: this.checkOutDate,
        roomCount: this.roomNum,
        guestCount: this.guestNum,
        cwtCityCode: this.searchInfo.city.cityCode,
        city: this.searchInfo.city,
        keyword: this.keyword, //this.searchInfo.keyword,
        keywordType: this.keywordType,
        distSelected: this.searchInfo.distSelected,
        priceArea:this.priceArea,
        priceAreaValue:this.priceAreaValue,
        stars: this.starSelect,
        groupCode:this.hotelGroupSelect,
        showStar:this.showstar,
        showPrice:this.show,
        radius: this.value,
      };
      this.$router.push({
        name: "Result",
        query: {
          searchParam: JSON.stringify(mapParam),
          sourceType: this.$objBaseInfo.sourceType,
        },
      });
    },
    onChange(index) {
      this.hotelID = this.hotelList[index].hotelDescriptiveInfo.id;
      this.hotelList.map((list) => {
        let id = list.hotelDescriptiveInfo.id;
        if (id === this.hotelID) {
          let marker = new AMap.Marker({
            position: [
              list.hotelDescriptiveInfo.location[1].longitude,
              list.hotelDescriptiveInfo.location[1].latitude,
            ],
          });
          this.map.add(marker);
          marker.on("click", this.openInfo);
          let info = [];
          info.push(`
            <div style="color:#FC6640;
              font-size: 1.8rem;
              float: right;
              cursor: pointer;">${ (list.currencyCode ? this.$currencySign[list.currencyCode] : this.$objBaseInfo.defaultCurrencySign) +  list.averagePrice}</div>
          `);
          let infoWindow = new AMap.InfoWindow({
            // isCustom: true, //使用自定义窗体
            autoMove: true,
            content: info.join(""), //使用默认信息窗体框样式，显示信息内容
          });
          infoWindow.open(this.map, marker.getPosition());

          this.$forceUpdate();
        }
      });
    },
    goDetail: function (data) {
      let localGeo = { latitude: "", longitude: "" };
      if (data.hotelDescriptiveInfo.location) {
        localGeo = data.hotelDescriptiveInfo.location.find((item) => {
          if (item.geoType == "gps") {
            return item;
          }
        });
      }
      this.wholeLoading = true;
      // 校验是否有房型信息
      let params = {
        posCode: this.$objBaseInfo.poscode,
        hotelCode: data.hotelDescriptiveInfo.id.toString(),
        checkInDate: this.searchInfo.checkInAt,
        checkOutDate: this.searchInfo.checkOutAt,
        noGuests: this.roomNum,
        noRooms: this.guestNum,
        bookingContactId: this.$objBaseInfo.loginID,
        source: this.$objBaseInfo.sourceType, //请求来源OBT/CRM,供延时功能使用
        pageRequest: {
          page: 1,
          per_page: 20,
        },
        language: ["en-US", "zh-CN"],
        countryCode: this.$objBaseInfo.countryCode, //国家ID
        cwtCityCode: this.searchInfo.city.cityCode, //城市id
        groupCode:data.hotelDescriptiveInfo.group,
      };
      if(Object.prototype.hasOwnProperty.call(this.$objBaseInfo,"openResource"))
      {
        if(this.$objBaseInfo.openResource!=undefined && this.$objBaseInfo.openResource!="" && this.$objBaseInfo.openResource!=null)
        {
          params.openResource=JSON.parse(this.$objBaseInfo.openResource);
        }
      }
      let that = this;
      availabilityProperty(params)
        .then((res) => {
          that.wholeLoading = false;
          if (res.code == 200) {
            if (res.data.error.code != 0) {
              that.confirmFlag = true;
              that.confirmMsg =
                that.$t("ERRORMESSAGE." + res.data.error.code) ===
                "ERRORMESSAGE." + res.data.error.code
                  ? that.$t("ERRORMESSAGE.NOTFOUND")
                  : that.$t("ERRORMESSAGE." + res.data.error.code);
              console.log(
                "获取房型下拉框数据 请求失败, code:" , res.data.error.code,
                res.data.error.message
              );
            } else {
              if (data.currencyCode) {
                that.$objBaseInfo.defaultCurrencyCode = data.currencyCode;
                that.$objBaseInfo.defaultCurrencySign =
                  that.$currencySign[that.$objBaseInfo.defaultCurrencyCode];
              }
              //供房型页面使用
              that.$dictionaryData.Property = res;
              that.hotelCode = data.hotelDescriptiveInfo.id.toString();
              that.chooseCode = that.searchInfo.city.cityCode;
              that.checkIn = that.checkInDate
                ? that.checkInDate
                : that.searchInfo.checkInAt;
              that.checkOut = that.checkOutDate
                ? that.checkOutDate
                : that.searchInfo.checkOutAt;
              that.roomCount = that.roomNum
                ? that.roomNum
                : that.searchInfo.roomCount;
              that.guestCount = that.guestNum
                ? that.guestNum
                : that.searchInfo.guestCount;
              let detailParam = {
                paymentType: that.paymentType,
                checkInAt: that.checkIn,
                checkOutAt: that.checkOut,
                roomCount: that.roomCount,
                guestCount: that.guestCount,
                cwtCityCode: that.chooseCode,
                cwtCountryCode:this.$objBaseInfo.countryCode,
                hotelcode: that.hotelCode,
                isAp: data.isAgencyPreferredHotel,
                isCp: data.isClientPreferredHotel,
                latitude: localGeo.latitude.toString(),
                longitude: localGeo.longitude.toString(),
                sourceType: that.$objBaseInfo.sourceType,
                groupId:data.hotelDescriptiveInfo.group,
                cwtMark:data.hotelDescriptiveInfo.cwtMarkCode,
              };
              sessionStorage.setItem("mapData", JSON.stringify(data));
              that.$router.push({
                name: "Detail",
                query: detailParam,
              });
            }
          } else {
            that.confirmFlag = true;
            that.confirmMsg =
              that.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code
                ? that.$t("ERRORMESSAGE.NOTFOUND")
                : that.$t("ERRORMESSAGE." + res.code);
            console.log(
              "获取房型下拉框数据 请求失败, code:" , res.code,
              res.message
            );
          }
        })
        .catch(function (error) {
          that.wholeLoading = false;
          that.confirmFlag = true;
          that.confirmMsg = that.$t("ERRORMESSAGE." + error.mesCode);
          console.log("获取房型下拉框数据 请求失败", error.objError);
        });
    },
    // 第一次进入页面，搜索触发
    getcityInfo(value) {
      this.checkpaymentType(value.city.cityInfo);
      this.keywordType = value.keywordType;
      this.roomNum = value.roomNum;
      this.guestNum = value.guestNum;
      this.keyword = value.keyword;
      if (value.city) {
        if (value.keywordType == "input") {
          value.city.cityInfo.locationType = 0;
        }
        // 更改目的城市
        if (value.city.cityCode != this.searchInfo.city.cityCode || value.keyword) {
          this.isFirstExec = true;
        }
        this.searchInfo.city = value.city;
        this.$objBaseInfo.countryCode = value.city.cityInfo.countryCode;
        this.$objBaseInfo.isGATCity = isCityGAT(value.city.cityInfo.provinceCode);
        this.$objBaseInfo.provinceCode = value.city.cityInfo.provinceCode;
        if (!this.keyword && value.city.cityInfo && value.city.cityInfo.locationType != 0) {
          this.keywordInput = {keyword:value.city.cityInfo.locationName[this.$t("RESULT.RESPONSEDATA.locationNameLists")], keywordType: "auto"};
        }
        if (value.city.cityInfo.locationType != 0) {
          let locationInfo = {
            locationNameLists: value.city.cityInfo.locationName,
            longitude: value.city.cityInfo.locationLongitude,
            latitude: value.city.cityInfo.locationLatitude,
            geoCodeType: value.city.cityInfo.locationGeoCodeType,
            locationCode: value.city.cityInfo.locationCode,
          };
          switch (value.city.cityInfo.locationType) {
            case 1:
              this.clearHandle("first", locationInfo);
              break;
            case 2:
              this.clearHandle("second", locationInfo);
              break;
            case 3:
              this.clearHandle("third", locationInfo);
              break;
            case 4:
              this.clearHandle("four", locationInfo);
              break;
          }
        } else {
          this.clearHandle("first", {});
        }
      }
      else {
        this.clearHandle("first", {});
      }
      this.cityCenterPos = [
        this.searchInfo.city.cityInfo.longitude,
        this.searchInfo.city.cityInfo.latitude,
      ];
      this.geoCodeType = this.searchInfo.city.cityInfo.geoCodeType;
      this.checkInDate = value.checkInDate;
      this.checkOutDate = value.checkOutDate;
      this.value = null;
      this.noMore = false;
      this.mapDisplay = true;
      this.showstar = 3;
      this.show = 3;
      this.sortByPrice = null;
      this.sortByStarRating = null;
      this.isCityChange = value.isCityChange;
      this.getHotelData("button");
    },
    // 搜索条件异常会返回空
    hotelInfo(value) {
      this.wholeLoading = false;
      this.hotelList = value;
      this.initMap("hand");
    },
    /**
     * @param {string} [queryType] - rolling:滚动查询;button:搜索按钮查询;不传参:其他查询
     */
    async getHotelData(queryType) {
      try {
        if(queryType == "button"){
          this.searchAnnouncementInfo();
        }
        if(this.$objBaseInfo.sourceType == "OBT"){
          this.searchHotHotel();
        }
        let params = {
          posCode: this.$objBaseInfo.poscode,
          bookingContactId: this.$objBaseInfo.loginID, //联系人ID
          countryCode: this.$objBaseInfo.countryCode, //国家ID
          cwtCityCode: this.searchInfo.city.cityCode,
          radiusUnit: "km",
          checkInDate: formatDateTime(this.checkInDate, "YYYY-MM-DD"),
          checkOutDate: formatDateTime(this.checkOutDate, "YYYY-MM-DD"),
          noGuests: this.guestNum,
          noRooms: this.roomNum,
          sources: [],
          keyword: this.keywordType == "input" ? this.keyword : "",
          SortByStarRating: this.sortByStarRating,
          SortByPrice: this.sortByPrice,
          pageRequest: {
            page: 1,
            per_page: 10,
          },
          Language: ["en-US", "zh-CN"],
        };
        if (!this.isFirstExec) {
          params.radius = this.radiusDist ? this.radiusDist : "5";
          params.coordinates = {
            latitude: parseFloat(this.centerPos[1]),
            longitude: parseFloat(this.centerPos[0]),
            geoType: this.geoCodeType,
          };
        } else {
          this.radiusDist = this.value ? this.value : null;
          if (
            this.searchInfo.city.cityInfo.locationType &&
            this.searchInfo.city.cityInfo.locationType != 0
          ) {
            if (this.searchInfo.city.cityInfo.locationType == 1) {
              params.cwtLocationCode = this.searchInfo.city.cityInfo.locationCode;
            }
            params.radius = this.radiusDist ? this.radiusDist : "5";
            params.coordinates = {
              latitude: parseFloat(this.searchInfo.city.cityInfo.locationLatitude),
              longitude: parseFloat(this.searchInfo.city.cityInfo.locationLongitude),
              geoType: this.searchInfo.city.cityInfo.locationGeoCodeType,
            };
          }
          
          if (this.tabName == "first" || this.tabName == ""|| this.tabName == "five") {
          params.cwtLocationCode = this.locationCode;
          // Hotelparams.radius = null;
          delete params["coordinates"];
          delete params.radius;
          delete params.radiusUnit;
          if(this.keywordType == "auto"){
            delete params.keyword;
          }
          } else {
            params.radius = this.radiusDist ? this.radiusDist : "5";
            this.coordinates.longitude = this.labelLongitude;
            this.coordinates.latitude = this.labelLatitude;
            this.coordinates.geoType = this.geoCodeType;
            params["coordinates"] = this.coordinates;
          }
          if (this.$objBaseInfo.destinationType == "I" && this.searchInfo.distSelected) {
              params.radius = this.searchInfo.distSelected;
              params.radiusUnit = "km";
          }
        }
        if(Object.prototype.hasOwnProperty.call(this.$objBaseInfo,"openResource"))
        {
          if(this.$objBaseInfo.openResource!=undefined && this.$objBaseInfo.openResource!="" && this.$objBaseInfo.openResource!=null)
          {
            params.openResource=JSON.parse(this.$objBaseInfo.openResource);
          }
        }
        this.wholeLoading = true;
        let $this = this;
        availabilityArea(params)
          .then((res) => {
            if (res.code == 200) {
              if (res.data.error.code != 0) {
                $this.hotelList = [];
                $this.confirmFlag = true;
                $this.confirmMsg =
                  $this.$t("ERRORMESSAGE." + res.data.error.code) ===
                  "ERRORMESSAGE." + res.data.error.code
                    ? $this.$t("ERRORMESSAGE.NOTFOUND")
                    : $this.$t("ERRORMESSAGE." + res.data.error.code);
                console.log(
                  "获取酒店列表数据 请求失败, code:" , res.data.error.code,
                  res.data.error.message
                );
              } else {
                $this.hotelList = res.data.hotelList;
              }
            } else {
              $this.hotelList = [];
              $this.confirmFlag = true;
              $this.confirmMsg =
                $this.$t("ERRORMESSAGE." + res.code) ===
                "ERRORMESSAGE." + res.code
                  ? $this.$t("ERRORMESSAGE.NOTFOUND")
                  : $this.$t("ERRORMESSAGE." + res.code);
              console.log(
                "获取酒店列表数据 请求失败, code:" , res.code,
                res.message
              );
            }
            $this.initMap("auto");
          })
          .catch((error) => {
            $this.confirmFlag = true;
            $this.confirmMsg = $this.$t("ERRORMESSAGE." + error.mesCode);
            console.log("获取酒店列表数据 请求失败, code:" , error.objError);
            $this.hotelList = [];
            $this.initMap("auto");
          });
      } catch (e) {
        this.wholeLoading = false;
        this.confirmFlag = true;
        this.confirmMsg = this.$t("ERRORMESSAGE." + e.mesCode);
        console.log("获取酒店列表数据 请求失败", e);
      }
    },
    arrayToObj(arr,posHotelTravelRuleDescFlag,posHotelTravelRuleDescCn,posHotelTravelRuleDescEn, currencySign) {
      let arrResult = [],
      strResult1 = "",
      strResult2 = "",
      strResult = "";
      if(this.$objBaseInfo.policySwitch && this.$objBaseInfo.personalizationPolicySwitch && this.$objBaseInfo.personalizationPolicyInfo){
        strResult = this.$i18n.locale == "en"?this.$objBaseInfo.personalizationPolicyInfo.descEn : this.$objBaseInfo.personalizationPolicyInfo.descCn;
        if(posHotelTravelRuleDescFlag)
        {
           strResult = this.$i18n.locale == "en"?posHotelTravelRuleDescEn : posHotelTravelRuleDescCn;
        }
      }else{
        if (arr.length == 0) {
          strResult = this.$t("RESULT.OUTOFPOLICYTIPEMPTY");
        } else {
          for (let obj in arr) {
            let objOutofPolicy = {};
            if (arr[obj]["key"] === "amountTopLimit") {
              objOutofPolicy.price = arr[obj]["value"];
              strResult1 = this.$t("RESULT.OUTOFPOLICYTIP1", {
                price: currencySign + objOutofPolicy.price,
              });
            } 
            if (arr[obj]["key"] === "NegotiationPrice") {
              // objOutofPolicy.star = arr[obj]["value"];
              // strResult2 = this.$t("RESULT.OUTOFPOLICYTIP2", {
              //   star: objOutofPolicy.star,
              // });
              strResult2 =  this.$t("RESULT.OUTOFPOLICYTIP3");
            }
          }

          strResult = strResult1 + (strResult1 === "" ? "" : "<br>") + strResult2;
        }
      }
      arrResult.push(strResult);
      return arrResult;
    },
    initMap(type) {
      if (this.hotelList && this.hotelList.length > 0) {
        type = "auto";
        this.isExistHotel = true;
        if (this.initMapType != "move") {
          this.centerPos = [
            this.hotelList[0].hotelDescriptiveInfo.location[1].longitude,
            this.hotelList[0].hotelDescriptiveInfo.location[1].latitude,  
          ];
          this.geoCodeType =
            this.hotelList[0].hotelDescriptiveInfo.location[1].geoType;
        } else {
          this.initMapType = "";
        }
      } else {
        type = "hand";
        this.isExistHotel = false;
        //this.centerPos = this.cityCenterPos;
      }
      if (!this.map) {
        this.wholeLoading = true;
        let foreignLang = "style_zh_cn";
        if (this.$i18n.locale === "en") {
          this.mapLanguage = "en";
          foreignLang = "style_en";
        } else {
          this.mapLanguage = "zh_cn";
          foreignLang = "style_zh_cn";
        }

        //创建地图实例
        this.map = new AMap.Map("container", {
          zoom: 11,
          center: this.centerPos,
          resizeEnable: true,
          vectorMapForeign: foreignLang,
          lang: this.mapLanguage,
        });
        this.map.on("complete", this.complateMap);
        //地图触摸平移 仅支持移动端触发此事件
        this.map.on("touchend", this.mapMoveend);
      } else {
        this.wholeLoading = false;
        this.map.setCenter(this.centerPos);
      }
      this.map.clearMap();
      if (type == "auto") {
        this.addMarker();
      }
    },
    // 添加标记点
    addMarker() {
      let that = this;
      that.hotelList.forEach((item) => {
        let positions = [
          item.hotelDescriptiveInfo.location[1].longitude,
          item.hotelDescriptiveInfo.location[1].latitude,
        ];
        let marker = new AMap.Marker({
          position: positions,
        });
        that.map.add(marker);
        marker.on("click", that.openInfo);
      });
      if(this.selectLocationCode.longitude !=undefined && this.treeActive == 2){
        let positions = [
        this.selectLocationCode.longitude,
        this.selectLocationCode.latitude,
        ];
        let marker = new AMap.Marker({
          position: positions,
          icon: new AMap.Icon({
            image: require("@/icon/img/mark_bs.png"),
            imageSize: new AMap.Size(19,33),
          }),
        });
        that.map.add(marker);
        //this.map.setCenter(positions);
      }
      that.$nextTick(() => {
        that.onChange(0);
        this.$refs.prev.swipeTo(0);
        that.setPriceAffix();
      });
      that.$forceUpdate();
    },
    //地图加载完成
    complateMap() {
      this.wholeLoading = false;
    },
    //触摸平移
    mapMoveend() {
      this.initMapType = "move";
      this.geoCodeType = "gaode";
      this.getDist("hand");
      this.keywordInput = {keyword: "", keywordType: "input"};
    },
    openInfo(e) {
      this.marketpoint = e.target.getPosition();
      this.hotelList.map((list) => {
        let location = null;
        if (list.hotelDescriptiveInfo.location[1].geoType == "gps") {
          location = list.hotelDescriptiveInfo.location;
          if (location[1].latitude == this.marketpoint.Q) {
            this.$refs.prev.swipeTo(this.hotelList.indexOf(list));
            //构建信息窗体中显示的内容
            let info = [];
            info.push(`
              <div style="color:#FC6640;
                font-size: 1.8rem;
                float: right;
                cursor: pointer;">${ (list.currencyCode ? this.$currencySign[list.currencyCode] : this.$objBaseInfo.defaultCurrencySign) +  list.averagePrice}</div>
            `);
            var infoWindow = new AMap.InfoWindow({
              // isCustom: true,  //使用自定义窗体
              autoMove: false,
              content: info.join(""), //使用默认信息窗体框样式，显示信息内容
            });
            infoWindow.open(this.map, e.target.getPosition());
            this.$forceUpdate();
          }
        }
      });
    },
    //计算距离
    getDist(type) {
      let centerMove = this.map.getCenter();
      this.centerPos = [centerMove.R, centerMove.Q];
      //计算屏幕宽度一半到中心点的实际距离
      let size =  parseInt((this.map.getSize()).getHeight() / 2);
      let pixelCon = new AMap.Pixel(0, size);
      let lat = this.map.containerToLngLat(pixelCon);
      let lngLat = new AMap.LngLat(this.centerPos[0], this.centerPos[1]);
      this.radiusDist = parseInt(lngLat.distance(lat)) / 1000; //km
      if (type === "hand") {
        this.isFirstExec = false;
        this.searchInfo.distSelected = null;
        this.getHotelData();
      }
    },
     //移动端
    distMenuOpen() {
      // if (this.$objBaseInfo.destinationType == "I" && this.selectMenuActive == 0) {
      //   this.treeActive = 1;
      // } else {
      //   this.treeActive = this.selectMenuActive;
      // }
      this.$nextTick(() => {
        if (document.querySelector(".van-sidebar-item")) {
          document.querySelector(".van-sidebar-item").style.display = "none";
        }
      });
      switch (this.selectMenuActive) {
        case 0:
          this.areaRadio = this.selectLocationCode.locationCode;
          this.choseArea = this.selectLocationCode;
          break;
        case 1:
          this.waySelected = this.selectLocationCode.locationCode;
          this.choseWay = this.selectLocationCode;
          break;
        case 2:
          this.customSelected = this.selectLocationCode.locationCode;
          this.choseCustom = this.selectLocationCode;
          break;
      }
    },
    // 距离切换
    distClick(val) {
      this.distSelected = val;
    },
     // 地区切换
    areaChange(item) {
      this.areaRadio = item.locationCode;
      this.choseArea = item;
    },
    hotHotelClick(val){
      this.hotHotelSelected = val.hotelCode;
      this.chosehotHote = val;
    },
    // 树形菜单确认按钮
    onTreeConfirm(locationInfo) {
      
      this.isAddTags = false;
      this.isFirstExec = true;
      let locationChose = {};
      if (this.treeActive == 0) {
        // 地区切换
        this.tabName = "first";
        if (this.areaRadio) {
          locationChose = this.choseArea;
          this.isAddTags = true;
        }
        this.value = null;
        this.customSelected = this.waySelected = this.hotHotelSelected = "";
      } else if (this.treeActive == 1) {
        //机场/火车站
        this.tabName = "second";
        if (this.waySelected) {
          locationChose = this.choseWay;
          this.isAddTags = true;
        } else if(this.$objBaseInfo.destinationType != 'I') {
          // 未选中机场火车站
          showToast(this.$t("RESULT.MOBILESELECTAIR"));
          return false;
        }
        this.value = this.distSelected;
        this.customSelected = this.areaRadio = this.hotHotelSelected = "";
      } else if (this.treeActive == 2) {
        //自定义地标
        this.tabName = "third";
        if (this.customSelected) {
          locationChose = this.choseCustom;
          this.isAddTags = true;
        } else if(this.$objBaseInfo.destinationType != 'I') {
          showToast(this.$t("RESULT.MOBILESELECTCUSTOMER"));
          // 未选中自定义坐标
          return false;
        }
        this.value = this.distSelected;
        this.waySelected = this.areaRadio = this.hotHotelSelected = "";
      }else if (this.treeActive == 3) {
        //热门酒店
        this.tabName = "five";
        if (this.hotHotelSelected) {
          this.keyword = this.chosehotHote.hotelName[this.$t('RESULT.RESPONSEDATA.locationNameLists')];
          this.isAddTags = true;
        } else {
          showToast(this.$t("RESULT.MOBILESELECTHOTHOTEL"));
          // 未选中热门酒店
          return false;
        }
        this.value = null;
        this.waySelected = this.areaRadio = this.customSelected = "";
      }
      this.selectMenuActive = this.treeActive;
      this.selectLocationCode = locationChose;
      if (locationChose != {} && locationChose.locationCode) {
        this.labelLongitude = locationChose.longitude;
        this.labelLatitude = locationChose.latitude;
        this.geoCodeType = locationChose.geoCodeType;
        this.locationCode = locationChose.locationCode;
        this.keywordInput = {keyword: locationChose.locationNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")], keywordType: "auto"};
        this.keyword = locationChose.locationNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")];
        //添加菜单选中颜色
        this.titleActive = "location_active"; //location_active

        this.searchInfo.city.cityInfo.locationName = locationChose.locationNameLists;
        this.searchInfo.city.cityInfo.locationCnName = locationChose.locationName;
        this.searchInfo.city.cityInfo.locationCode = locationChose.locationCode;
        this.searchInfo.city.cityInfo.locationEnName = locationChose.locationNameLists.en;
        this.searchInfo.city.cityInfo.locationLatitude = locationChose.latitude;
        this.searchInfo.city.cityInfo.locationLongitude = locationChose.longitude;
        this.searchInfo.city.cityInfo.locationType = this.treeActive + 1;
        this.keywordType = "auto";

      }else if (this.treeActive == 3) {
        this.keywordInput = {keyword: this.keyword, keywordType: "input"};
        this.labelLongitude = "";
        this.labelLatitude = "";
        this.geoCodeType = "";
        this.locationCode = "";
        this.selectLocationCode = {};
        this.keywordType = "input";
        //添加菜单选中颜色
        this.titleActive = "location_active"; //location_active
      } else {
        this.keywordInput = {keyword: this.keyword, keywordType: "input"};
        this.labelLongitude = "";
        this.labelLatitude = "";
        this.geoCodeType = "";
        this.locationCode = "";
        this.selectLocationCode = {};
        // 清空菜单颜色
        this.titleActive = "";
      }

      this.$refs.location.toggle(false);
      //landmark处理
      if (this.tabName == "four") {
        this.isAddTags = true;
        this.value = 5;
        this.labelLongitude = locationInfo.longitude;
        this.labelLatitude = locationInfo.latitude;
        this.geoCodeType = locationInfo.geoCodeType;
        this.locationCode = locationInfo.locationCode;
        this.keywordInput = {keyword: locationInfo.locationNameLists[this.$t("COMMONPARAM.RESPONSEDATA.SHOWTYPE")], keywordType: "auto"};
      }
      if (this.searchInfo.distSelected && this.$objBaseInfo.destinationType == "I") {
        this.value = this.searchInfo.distSelected;
      }
      if(locationInfo.isTrusted)
      {
        this.getHotelData();
      }
      
    },
    onTreeReset() {
      this.treeActive = 0;
      this.areaRadio = "";
      this.waySelected = "";
      this.customSelected = "";
      this.hotHotelSelected = "";
      this.keyword = "";
      if (this.$objBaseInfo.destinationType == "I") {
        this.distClick(50);
      } else {
        this.distSelected = null;
      }
      delete this.searchInfo.city.cityInfo.locationName;
      delete this.searchInfo.city.cityInfo.locationCnName;
      delete this.searchInfo.city.cityInfo.locationCode;
      delete this.searchInfo.city.cityInfo.locationEnName;
      delete this.searchInfo.city.cityInfo.locationLatitude;
      delete this.searchInfo.city.cityInfo.locationLongitude;
      this.searchInfo.city.cityInfo.locationType = this.treeActive;
    },
    clearHandle(tabName, locationInfo) {
      
        switch (tabName) {
          case "first":
            this.treeActive = 0;
            this.areaRadio = locationInfo.locationCode;
            this.choseArea = locationInfo;
            break;
          case "second":
            this.treeActive = 1;
            this.waySelected = locationInfo.locationCode;
            this.choseWay = locationInfo;
            this.distSelected = 5;
            break;
          case "third":
            this.treeActive = 2;
            this.customSelected = locationInfo.locationCode;
            this.choseCustom = locationInfo;
            this.distSelected = 5;
            break;
          case "four":
            this.tabName = tabName;
            this.treeActive = 3;
            break;
        }
        this.onTreeConfirm(locationInfo);
    },
    locationInfo(value) {
      this.locationInformation = value;
      this.customlocationGet();
      this.airportGet();
      // this.$nextTick(() => {
      //   this.height();
      // });
    },
    airportGet() {
      this.locationType = 2;
      this.getLocationData(2);
    },
    customlocationGet() {
      this.locationType = 3;
      this.getLocationData(3);
    },
    async getLocationData(type) {
      let that = this;
      this.loading = true;
      try {
        this.chooseCode = this.cityInfo ? this.cityInfo : this.searchInfo.city.cityCode;
        let params = { params: { CityCode: this.chooseCode, LocationType: type, isEnable: 1 } };
        if (this.tabName == 'third' || type == 3) {
          params.params.customerCode = this.$objBaseInfo.customerCode;
        }
        const res = await locationList(params);
        if (res.code == 200) {
          if (res.data.list && res.data.list.length > 0) {
            if (type == 2) {
              //this.haveAirports = true;
              // if (this.$objBaseInfo.destinationType == "I") {
              //   this.activeName = "second";
              // }
              this.airportslocationInfo = res.data.list;
            }
            if (type == 3) {
              // this.haveCustoms = true;
              // if (this.$objBaseInfo.destinationType == "I") {
              //   this.activeName = "third";
              // }
              this.customlocationInfo = res.data.list;
            }
          } else {
            if (type == 2) {
              //this.haveAirports = false;
              this.airportslocationInfo = [];
            }
            if (type == 3) {
              //this.haveCustoms = false;
              this.customlocationInfo = [];
            }
          }
          this.loading = false;
          // this.$nextTick(() => {
          //   this.height();
          // });
          if (res.data.error.code != 0) {
            that.confirmFlag = true;
            that.confirmMsg = that.$t("ERRORMESSAGE." + res.data.error.code) === "ERRORMESSAGE." + res.data.error.code ? that.$t("ERRORMESSAGE.NOTFOUND") : that.$t("ERRORMESSAGE." + res.data.error.code);
          }
        } else {
          that.confirmFlag = true;
          that.confirmMsg = that.$t("ERRORMESSAGE." + res.code) === "ERRORMESSAGE." + res.code ? that.$t("ERRORMESSAGE.NOTFOUND") : that.$t("ERRORMESSAGE." + res.code);
        }

      } catch (e) {
        that.confirmFlag = true;
        that.confirmMsg = that.$t("ERRORMESSAGE.500");
        console.log("try-catch", e);
      }
    },
    // 自定义坐标切换
    customClick(val) {
      this.customSelected = val.locationCode;
      this.choseCustom = val;
    },
    // 机场火车站切换
    wayClick(val) {
      this.waySelected = val.locationCode;
      this.choseWay = val;
    },
    searchAnnouncementInfo(){
      var cityInfo = this.searchInfo.city;
      let announcementParams = {
        params: {
          customerCode: this.$objBaseInfo.customerCode,
          cityCode: cityInfo.cityCode,
          cityName:decodeURI(cityInfo.cityName),
          countryCode:cityInfo.cityInfo.countryCode,
          posCode:this.$objBaseInfo.poscode,
          channelID: this.$objBaseInfo.channelId,
          lang:this.$i18n.locale == "en"? this.$i18n.locale : "zh-CN"
        },
      };
      getAnnouncementInfo(announcementParams)
        .then((res) => {
          if (res.code == 200) {
            if(res.data.isPopUp && (sessionStorage.getItem("isFirstIntoResult") == "true" || this.isCityChange)){
              sessionStorage.setItem("isFirstIntoResult", false);
              this.hotelListNoticeDialogVisible = true;
            }
            this.$objBaseInfo.announcementNotice = res.data.notice;
            if(res.data.isNavigationBarLabel){
              this.showHotelListNotice = true;
              if (this.$i18n.locale == "en"){
                this.noticeTitle = res.data.title["en"];
              }else{
                this.noticeTitle = res.data.title["zh-CN"];
              }
            }else{
              this.showHotelListNotice = false;
            }
          } 
        })
        .catch((err) => {
      });
    },
    //Announcement
    setAnnouncementFlag(value) {
      this.hotelListNoticeDialogVisible = value;
    },
    searchHotHotel(){
      var cityInfo = this.searchInfo.city;
      let hotHotelParams = {
        params: {
          cityCode: cityInfo.cityCode,
        },
      };
      gethothotel(hotHotelParams)
        .then((res) => {
          if (res.code == 200) {
            if(res.data && res.data.hotHotelList.length > 0){
              this.hotHotelInfo = res.data.hotHotelList;
              this.showHotHotel = true;
            }else{
              this.showHotHotel = false;
            }
          }else{
            this.showHotHotel = false;
          }
        })
        .catch((err) => {
          this.showHotHotel = false;
        });
    },
    choseHotHotel(val){
      
      this.keyword = val.hotelName[this.$t('RESULT.RESPONSEDATA.locationNameLists')];
      this.keywordInput = {keyword: this.keyword, keywordType: "input"};
      this.getHotelData();
    },
    checkpaymentType(cityInfo){
      if(this.$objBaseInfo.openResource){
        var data = JSON.parse(this.$objBaseInfo.openResource);
        this.isCorpPay = false;
        this.isHotelPay = false;
        this.isPrepay = false;
        if(this.$objBaseInfo.destinationType === "I" && data.International.includes("3")){//国际是否开启公付
          this.isCorpPay = true;
        }else if (this.$objBaseInfo.destinationType === "I" && data.International.includes("1")){//国际是否开启现付
          this.isHotelPay = true;
        }else if (this.$objBaseInfo.destinationType === "I" && data.International.includes("2")){//国际是否开启预付
          this.isPrepay = true;
        }
        if (cityInfo && cityInfo != {} && this.$objBaseInfo.destinationType === "D") {
          if(isCityGAT(cityInfo.provinceCode)){
            if(data.GangAoTai.includes("3")){//港澳台是否开启公付
              this.isCorpPay = true;
            }
            if(data.GangAoTai.includes("1")){//港澳台是否开启现付
              this.isHotelPay = true;
            }
            if(data.GangAoTai.includes("2")){//港澳台是否开启预付
              this.isPrepay = true;
            }
          }else{
            if(data.Domestic.includes("3")){//大陆是否开启公付
              this.isCorpPay = true;
            }
            if(data.Domestic.includes("1")){//大陆是否开启现付
              this.isHotelPay = true;
            }
            if(data.Domestic.includes("2")){//大陆是否开启预付
              this.isPrepay = true;
            }
          }
        } 
      }
    },
  },
};
</script>
<style>
@media screen and (max-width: 960px) {

  .van-dropdown-menu__item{
    justify-content:left;
  }

  .location_active{
    position: relative;
  }

  .location_active::before{
    content: "";
    border: 3px solid red;
    border-radius: 3px;
    position: absolute;
    z-index: 1000;
    left: 2rem;
    bottom: 2.6rem;
  }
  .hotel_list_price_map {
    font-size: 1.6rem;
    /* margin-right: -1rem; */
  }

  .hotel_list_price_map::after {
    content: attr(data-content-after);
    font-size: 1.5rem;
    margin-right: 0.5rem;
  }

  .hotel_list_price_map::before {
    content: attr(data-content-before);
    font-size: 1.5rem;
    margin-left: -1rem;
  }
  .priceBottom {
    margin-top: 0.5rem;
    text-align: right;
    display: block;
  }
  .row-address {
    margin-top: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
  .row-phone {
    margin-top: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .result_btn {
    position: absolute;
    height: 4.5rem;
    right: 0.5rem;
    top: 8rem;
    z-index: 1;
  }
  .result_btn .el-button {
    font-size: 1.4rem;
  }
  .el-button [class*=el-icon-]+span{
    margin-left: 0px;
  }
  .noMore {
    position: fixed;
    top: 90%;
    left: 30%;
    color: #333f48;
    background: white;
  }
  .my-swipe {
    height: 15rem;
    background-color: #ffffff;
    border-radius: 1rem;
    border: 1px solid #ebeaea;
  }
  .loading {
    z-index: 99;
  }
  .list_area {
    width: 70%;
    position: fixed;
    bottom: 2%;
    left: 15%;
  }
  .hotel_title {
    font-size: 1.6rem;
    margin: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .row-second {
    margin-left: 1rem;
  }
  .pricePolicy {
    min-width: 11rem;
    /* height: 3rem; */
    font-size: 1.4rem;
    color: #f2a900;
    /* margin-top: 0.5rem; */
    /* padding-left: 1rem; */
  }
  .mainContet {
    position: fixed;
    width: 100%;
    top: 11rem;
    bottom: 0;
    z-index: 0;
    overflow: hidden;
  }
  .map_area {
    height: 100%;
  }
  .mobile-map-list {
    position: relative;
  }
  .top-nav-mobile {
    position: relative;
    z-index: 1;
    padding: 0.1rem;
    background: white;
    border-top: 1px solid #fc6640;
  }
  :deep(.amap-info-close) {
    display: none;
  }
  
}
.policy_outof_in{
  margin: 0;
  width: 12rem;
}

.van-radio__icon .van-icon {
  border: 0px;
}

.van-tag--primary.van-tag--plain {
  margin: 1rem;
  padding: 1rem 2rem;
  font-size: 1.4rem;
  background: #eeeeee;
  color: #39393a;
}
.dist-title {
  margin-left: 1rem;
  font-size: 1.6rem;
  color: gray;
}
.van-tag--plain::before {
  border: 0px;
}
.click-dist-tag {
  background: #409eff !important;
  color: white !important;
}
.van-tree-select__content {
  -webkit-box-flex: 3;
  flex: 3;
}
.van-sidebar-item {
  font-size: 1.2rem;
}
.van-dropdown-menu__title,
.van-cell {
  font-size: 1.6rem;
}
.top-vant-btn {
  width: 45%;
  float: left;
  margin: 1rem;
}
.el-dialog{
  width: 80%!important;
}
.annoucement-tag {
  line-height: 4rem;
  position: absolute;
  right: 26%;
  height: 2.5rem;
  top: 7rem;
  z-index: 1;
  color: #1989fa!important;
}
</style>